import { initializeApp, getApp, getApps } from "firebase/app";
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber, GoogleAuthProvider, signInWithPopup, setPersistence, inMemoryPersistence, signOut } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDzQIPtFECdbt6HVjbr_zUIgLOOxn7zNjk",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "sophiasweeps.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "sophiasweeps",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "sophiasweeps.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "989298038608",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:989298038608:web:2009a79811881b4290fe55",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-HY33BG13J6",
};

export function isFirebasePhoneConfigured() {
  return Boolean(firebaseConfig.apiKey && firebaseConfig.authDomain && firebaseConfig.projectId && firebaseConfig.appId);
}

function getFirebaseAuth() {
  const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
  return getAuth(app);
}

export function resetFirebaseRecaptcha() {
  if (typeof window === "undefined") return;
  try {
    window.sophiaRecaptchaVerifier?.clear?.();
  } catch {
    // Firebase can throw if the verifier is already cleared.
  }
  window.sophiaRecaptchaVerifier = null;
}

function ensureRecaptcha(containerId) {
  const auth = getFirebaseAuth();
  if (window.sophiaRecaptchaVerifier) return window.sophiaRecaptchaVerifier;
  window.sophiaRecaptchaVerifier = new RecaptchaVerifier(auth, containerId, {
    size: "invisible",
  });
  return window.sophiaRecaptchaVerifier;
}

export async function sendFirebasePhoneCode(phoneNumber, containerId = "firebase-recaptcha-container") {
  if (!isFirebasePhoneConfigured()) {
    throw new Error("Firebase phone verification is not configured.");
  }
  const auth = getFirebaseAuth();
  const verifier = ensureRecaptcha(containerId);
  return signInWithPhoneNumber(auth, phoneNumber, verifier);
}

export async function getGoogleIdToken() {
  const auth = getFirebaseAuth();
  await setPersistence(auth, inMemoryPersistence);
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({ prompt: "select_account" });
  const result = await signInWithPopup(auth, provider);
  try { return await result.user.getIdToken(true); }
  finally { await signOut(auth); }
}

export async function sendSignupPhoneCode(phoneNumber, containerId) {
  await setPersistence(getFirebaseAuth(), inMemoryPersistence);
  return sendFirebasePhoneCode(phoneNumber, containerId);
}

export async function confirmSignupPhoneCode(confirmation, code) {
  const result = await confirmation.confirm(code);
  try { return await result.user.getIdToken(true); }
  finally { await signOut(getFirebaseAuth()); }
}
